import "./style.scss";
import $ from 'jquery';

$(document).ready(function () {
    $('.testimonials.cards--as-slider').slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        dotsClass: 'slick-dots list-no-bullets',
        responsive: [
            {
                breakpoint: 781,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});